<template>
  <div>
    <Loading v-if="loading" />
    <!-- Reps -->
    <div
      v-if="
        computedReps &&
          (currentView === 'this_system_reps' || currentView === 'admin_reps')
      "
    >
      <!-- Submenu -->
      <div class="sub-menu"    v-if="apidata.system.show_system_reps">
        <div
          href="#"
          :class="`${currentView === 'this_system_reps' ? 'active' : ''}`"
          @click="currentView = 'this_system_reps'"
        >
          {{ apidata.system.name }} Reps
        </div>
        <div
          href="#"
          :class="`${currentView === 'admin_reps' ? 'active' : ''}`"
          @click="currentView = 'admin_reps'"
          v-if="apidata.me.properties.tac_organisation === 'superior_press'"
        >
          Superior Press Reps
        </div>
      </div>
      <div class="cards reps" style="max-width: 600px">
        <div
          class="card rep"
          v-for="rep in computedReps[currentView]"
          :key="rep.id"
          @click="selectRep(rep)"
        >
          <div>
            <h3>
              {{ rep.properties.firstname }} {{ rep.properties.lastname }}
            </h3>
          </div>
          <div style="color: grey">View calendar & edit</div>
        </div>
      </div>
      <!-- Button -->
      <div style="margin-top: 20px">
        <button
          v-if="currentView === 'this_system_reps'"
          @click="showAddRep = !showAddRep"
          class="primary"
        >
          Add a new {{ apidata.system.name }} Rep.
        </button>
        <button
          v-if="currentView === 'admin_reps'"
          @click="showAddRep = !showAddRep"
          class="primary"
        >
          Add a new Superior Press Rep.
        </button>
      </div>
    </div>
    <AddEditRep
      :is_admin_rep="currentView === 'admin_reps' ? true : false"
      v-if="showAddRep"
      @close="showAddRep = !showAddRep"
      @created="createdRep"
    />
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      loading: null,
      currentView: "admin_reps",
      rawReps: null,
      computedReps: null,
      showAddRep: false,
    };
  },

  methods: {
    getReps: async function() {
      try {
        this.loading = true;
        const response = await this.$axios({
          method: "get",
          url: "https://enxlyzz4mrq4xlq.m.pipedream.net",
          params: {
            system_id: this.apidata.system.system_id,
          },
        });

        this.rawReps = response.data.results;

        this.computedReps = {
          this_system_reps: this.rawReps?.filter(
            (element) =>
              element.properties.tac_organisation !== "superior_press"
          ),
          admin_reps: this.rawReps?.filter(
            (element) =>
              element.properties.tac_organisation === "superior_press"
          ),
        };
      } catch (error) {
        this.$toast.error(error.message);
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    createdRep: async function() {
      await new Promise((resolve) => setTimeout(resolve, 3000));
      this.getReps();
    },
    selectRep: async function(rep) {
      this.$router.push(`/reps/${rep.id}`);
    },
  },

  created: async function() {
    await this.getReps();
  },
};
</script>

<style scoped>
.rep {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
